import {t} from '../utils/catalogueUi';

export const tabLabels = {
  overview: t('entity.newVehicle.catalogue.tabs.overview', 'Overview'),
  'trim-levels': t('entity.newVehicle.catalogue.tabs.trimLevels', 'Trim levels'),
  engines: t('entity.newVehicle.catalogue.tabs.engines', 'Engines'),
  'variant-matrix': t('entity.newVehicle.catalogue.tabs.variantMatrix', 'Variant matrix'),
  colours: t('entity.newVehicle.catalogue.tabs.colours', 'Colours'),
  upholstery: t('entity.newVehicle.catalogue.tabs.upholstery', 'Upholstery'),
  'colour-upholstery': t(
    'entity.newVehicle.catalogue.tabs.colourUpholstery',
    'Colour & upholstery'
  ),
  features: t('entity.newVehicle.catalogue.tabs.features', 'Features'),
  'equipment-by-trim': t('entity.newVehicle.catalogue.equipmentByTrim', 'Equipment by trim'),
  packages: t('entity.newVehicle.catalogue.tabs.packages', 'Packages'),
  rules: t('entity.newVehicle.catalogue.tabs.rules', 'Rules'),
} as const;

export type TabId = keyof typeof tabLabels;
